import { Logo } from './Logo';
import { QRPanel } from './QRPanel';
import { StoreBadges } from './StoreBadges';

interface Props {
  currentUrl: string;
  appStoreUrl: string;
  playStoreUrl: string;
  onAppStoreClick?: () => void;
  onPlayStoreClick?: () => void;
}

export function DesktopBrandPanel({
  currentUrl,
  appStoreUrl,
  playStoreUrl,
  onAppStoreClick,
  onPlayStoreClick,
}: Props) {
  return (
    <aside className="hidden h-full w-full flex-col bg-white px-12 py-14 lg:flex xl:px-16">
      <div className="flex items-center gap-2">
        <Logo className="h-7 w-auto" />
        <span className="text-base font-semibold tracking-tight text-slate-900">
          우리엔
        </span>
      </div>

      <div className="mt-16 flex max-w-md flex-col">
        <h1 className="text-3xl font-bold leading-tight tracking-tight text-slate-900 xl:text-4xl">
          반려동물의 일상을
          <br />
          더 가깝게 우리엔에서
        </h1>
        <p className="mt-4 text-base leading-relaxed text-slate-500">
          동물병원과 보호자를 잇는 케어 알림 서비스. 백신·예약·건강 기록을
          한 곳에서 관리하세요.
        </p>
      </div>

      <div className="mt-10 flex max-w-md flex-col gap-4">
        <QRPanel value={currentUrl} />
        <StoreBadges
          appStoreUrl={appStoreUrl}
          playStoreUrl={playStoreUrl}
          onAppStoreClick={onAppStoreClick}
          onPlayStoreClick={onPlayStoreClick}
        />
      </div>

      <div className="mt-auto pt-10 text-xs leading-relaxed text-slate-400">
        © {new Date().getFullYear()} Woorien. All rights reserved.
      </div>
    </aside>
  );
}
